interface EstadoBlocoProps {
    carregando: boolean;
    erro: boolean;
    onTentar?: () => void;
}

/** Loading e erro de um bloco, sem derrubar o resto da tela. */
export default function EstadoBloco({ carregando, erro, onTentar }: EstadoBlocoProps) {
    if (erro) {
        return (
            <div className="erro">
                Não foi possível carregar este bloco.{' '}
                {onTentar && (
                    <button type="button" className="clearall" onClick={onTentar}>Tentar de novo</button>
                )}
            </div>
        );
    }
    if (carregando) return <div className="empty">Carregando…</div>;
    return null;
}
